'use strict';

import React, { Component } from 'react'

import _ from 'lodash'

import { CSSTransition, TransitionGroup } from 'react-transition-group'

import Layout from '@Layout/BackOffice'

import UpdateForm from '@/Form/UpdateForm'

import config from '@Config/SynerQuizz/syner_quizz'

const { app } = window;

export default class SynerQuizzPage extends Component
{
	state = { };

	UNSAFE_componentWillMount ()
	{
		app.resetFunctions();
	}

	render ()
	{
		const props = this.props;

		var output =
		(
			<Layout page_title="Syner'Quizz" history={ props.history }>

				<div className="page-content">

					<div className="o-content">

						<TransitionGroup className="page-form-container">

							<CSSTransition
								classNames="a-form-transition"
								appear={ true }
								enter={ true }
								exit={ true }
								timeout={{ enter: 240, exit: 320, appear: 500 }}>

								<UpdateForm config={ config } />

							</CSSTransition>

						</TransitionGroup>

					</div>

				</div>

			</Layout>
		);

		return output;
	}
}